/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TemplateDiagnosis from './template-diagnosis';
import TemplateDiagnosisDetail from './template-diagnosis-detail';
import TemplateDiagnosisUpdate from './template-diagnosis-update';
import TemplateDiagnosisDeleteDialog from './template-diagnosis-delete-dialog';

const TemplateDiagnosisRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TemplateDiagnosis />} />
    <Route path="new" element={<TemplateDiagnosisUpdate />} />
    <Route path=":id">
      <Route index element={<TemplateDiagnosisDetail />} />
      <Route path="edit" element={<TemplateDiagnosisUpdate />} />
      <Route path="delete" element={<TemplateDiagnosisDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TemplateDiagnosisRoutes;
